import pluralize from 'pluralize';
import React from 'react';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';
import ProjectHealthReportDetails from './ProjectHealthReportDetails';

export default function BulkDelete({ ids, projectId, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Delete"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projects(projectId)
          .healthReports()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={ProjectHealthReportDetails}>
      {`Are you sure you want to delete ${ids.length} ${pluralize('project health report', ids.length)}? This action cannot be undone.`}
    </BulkActionModal>
  );
}
